import type { PortableTextComponents, PortableTextMarkComponent } from "@portabletext/react";

type LinkMark = {
  _type: "link";
  href?: string;
};

type FileLinkMark = {
  _type: "fileLink";
  url?: string;
  originalFilename?: string;
};

// Declared explicitly rather than relying on @portabletext/react's default, to match the schema's `href` field.
const Link: PortableTextMarkComponent<LinkMark> = ({ value, children }) => (
  <a href={value?.href}>{children}</a>
);

// Opens a document uploaded to Sanity. `url` is resolved from the file asset by the site config query.
const FileLink: PortableTextMarkComponent<FileLinkMark> = ({ value, children }) => {
  if (value?.url == null || value.url === "")
    return <>{children}</>;

  return (
    <a href={value.url} target="_blank" rel="noopener noreferrer" title={value.originalFilename}>
      {children}
    </a>
  );
};

export const usefulLinksComponents: PortableTextComponents = {
  marks: {
    link: Link,
    fileLink: FileLink,
  },
};
